import { render, staticRenderFns } from "./edit-resource.vue?vue&type=template&id=21281b9e&scoped=true&"
import script from "./edit-resource.vue?vue&type=script&lang=js&"
export * from "./edit-resource.vue?vue&type=script&lang=js&"
import style0 from "./edit-resource.vue?vue&type=style&index=0&id=21281b9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21281b9e",
  null
  
)

export default component.exports